import { useEffect, useState } from 'react'
import {
  OFFER_STATUS_CLOSED,
  STATUS_CANCELLED,
  STATUS_OFFER_DECLINED
} from 'tennders-stracture/libs/constants'
import useSession from 'tennders-auth/hooks/useSession'
import GHref from 'tennders-market/common/components/element/GHref'
import CounterOffer from 'tennders-market/offer/views/negotiation-for-shared/CounterOffer'
import useTranslation from 'next-translate/useTranslation'

const UnderNegotiation = ({
  offer, transaction,
  acceptOffer,
  declineOffer,
  continueNegotiate,
  revertOffers,
  sendBid, submitting,
  marketPlace
}) => {
  const { isBroker } = useSession()
  const isOwner = () => (marketPlace ? transaction?.isSharedWithMarketPlace : isBroker())
  const { t } = useTranslation()
  const [showCounter, setShowCounter] = useState(false)
  const [action, setAction] = useState('')

  useEffect(() => {
    setShowCounter(false)
  }, [])

  if (transaction?.status?.label === STATUS_CANCELLED) {
    return (
      <div className="w-50">
        <div className="p-16 ml-16 border-l pos-rel">
          <div className="text-center">
            <div className="d-flex row align-center">
              {t('transaction:noLongerAvailable')}
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (offer.status?.label === OFFER_STATUS_CLOSED) {
    return (
      <div className="w-50">
        <div className="p-16 ml-16 border-l pos-rel">
          <div className="text-center">
            <div className="d-flex row align-center">
              Previous Offer History
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (offer?.isTermsChanged) {
    if (isOwner()) {
      return (
        <div className="w-50">
          <div className="pl-16 ml-16 border-l">
            <div className="bold">{offer?.changedTerms}</div>
            <div className="mt-10 tennders-accept-counter-offer-btns pos-rel">
              <p>{t('transaction:waitForCarrier')}</p>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="w-50">
        <div className="pl-16 ml-16 border-l">
          <div className="bold">{offer?.changedTerms}</div>
          <div className="mt-10 tennders-accept-counter-offer-btns pos-rel">
            <GHref
              onClick={() => {
                setAction('continue'); continueNegotiate(offer)
              }}
              submitting={submitting && action === 'continue'}
              disabled={submitting && action === 'continue'}
              className="btn-border standard-btn small mr-10"
            >
              {t('transaction:continueWithLastState')}
            </GHref>
            <GHref
              submitting={submitting && action === 'revert'}
              onClick={() => {
                setAction('revert'); revertOffers(offer)
              }}
              disabled={submitting && action === 'revert'}
              className="btn-border standard-btn small mr-10  tennders-counter-btn"
            >
              {t('transaction:reNegotiate')}
            </GHref>
          </div>
        </div>
      </div>
    )
  }

  if (!offer?.lastOffer && offer?.status?.label === 'OFFER_WAITING') {
    if (isOwner()) {
      return (
        <div className="w-50">
          <div className="pl-16 ml-16 border-l">
            <div className="bold">{t('transaction:noResponse')}</div>
          </div>
        </div>
      )
    }

    return (
      <div className="w-50">
        <div className="p-16 ml-16 border-l pos-rel">
          <div className="tennders-accept-counter-offer-btns pos-rel">
            <GHref
              onClick={() => {
                setAction('accept')
                acceptOffer(offer)
              }}
              submitting={submitting && action === 'accept'}
              disabled={submitting && action === 'accept'}
              className="btn-border standard-btn small mr-10"
            >
              {t('transaction:acceptOffer')}
            </GHref>
            <GHref
              disabled={!transaction?.isOfferable || (submitting && action === 'counter')}
              submitting={submitting && action === 'counter'}
              onClick={() => {
                setAction('counter')
                setShowCounter(true)
              }}
              className="btn-border standard-btn small mr-10  tennders-counter-btn"
            >
              {t('transaction:counterOffer')}
            </GHref>
          </div>
          {showCounter && (
            <CounterOffer
              counterTo={null}
              sharedTransaction
              onClose={() => setShowCounter(false)}
              sendBid={sendBid}
              submitting={submitting}
              transaction={transaction}
            />
          )}
        </div>
      </div>
    )
  }

  if (offer?.lastOffer?.isMyOffer && offer?.status?.label !== STATUS_OFFER_DECLINED) {
    return (
      <div className="w-50">
        <div className="p-16 ml-16 border-l pos-rel">
          <div className="text-center">
            <div className="d-flex row align-center">
              Under Negotiation
            </div>
          </div>
        </div>
      </div>
    )
  }

  if ((offer?.status?.label === 'OFFER_NEGOTIATING' || offer?.status?.label === 'OFFER_WAITING')) {
    return (
      <div className="w-50">
        <div className="p-16 ml-16 border-l pos-rel">
          <div className="tennders-accept-counter-offer-btns pos-rel">
            <GHref
              disabled={!transaction?.isOfferable || (submitting && action === 'accept')}
              onClick={() => {
                setAction('accept')
                acceptOffer(offer?.lastOffer)
              }}
              submitting={submitting && action === 'accept'}
              className="btn-border standard-btn small mr-10"
            >
              {t('offer:acceptOffer')}
            </GHref>
            <GHref
              disabled={!transaction?.isOfferable}
              onClick={() => setShowCounter(true)}
              className="btn-border standard-btn small mr-10  tennders-counter-btn"
            >
              {t('offer:counterOffer')}
            </GHref>
          </div>
          {showCounter && (
            <CounterOffer
              sharedTransaction
              counterTo={offer?.lastOffer?.id}
              onClose={() => setShowCounter(false)}
              sendBid={sendBid}
              submitting={submitting}
              transaction={transaction}
            />
          )}
        </div>
      </div>
    )
  }

  return null
}

export default UnderNegotiation
